// @flow
import { defineMessages } from 'react-intl';
import { responsiveVars } from '../constants';

const { ZOOM_HOUR, ZOOM_30MINS, ZOOM_15MINS, ZOOM_10MINS, ZOOM_5MINS, ZOOM_2MINS, ZOOM_MINS } = responsiveVars;

export default defineMessages({
    [ZOOM_HOUR]: {
        id: 'zoom-component.hourly',
        defaultMessage: 'Hourly'
    },
    [ZOOM_30MINS]: {
        id: 'zoom-component.30Mins',
        defaultMessage: '30 Mins'
    },
    [ZOOM_15MINS]: {
        id: 'zoom-component.15Mins',
        defaultMessage: '15 Mins'
    },
    [ZOOM_10MINS]: {
        id: 'zoom-component.10Mins',
        defaultMessage: '10 Mins'
    },
    [ZOOM_5MINS]: {
        id: 'zoom-component.5Mins',
        defaultMessage: '5 Mins'
    },
    [ZOOM_2MINS]: {
        id: 'zoom-component.2Mins',
        defaultMessage: '2 Mins'
    },
    [ZOOM_MINS]: {
        id: 'zoom-component.AMinute',
        defaultMessage: 'A Minute'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/zoom/intl.js